// extracted by mini-css-extract-plugin
export default {"wrapper":"MobileMenu_wrapper__yklUy","button":"MobileMenu_button__wuQZ8","left":"MobileMenu_left__1ov39","right":"MobileMenu_right__jpQbr","title":"MobileMenu_title__J9Lai"};